import { render, staticRenderFns } from "./recordRemark.vue?vue&type=template&id=87de898c&scoped=true"
import script from "./recordRemark.vue?vue&type=script&lang=js"
export * from "./recordRemark.vue?vue&type=script&lang=js"
import style0 from "./recordRemark.vue?vue&type=style&index=0&id=87de898c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87de898c",
  null
  
)

export default component.exports